<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-card">
      <header>
        <div>
          <h3>Choose a message type</h3>
          <p class="hint">
            Each type maps to a different Apple retention experience.
            Pick one to start; the type is locked once the draft is saved.
          </p>
        </div>
        <button
          class="icon-btn"
          @click="$emit('close')"
          type="button"
          aria-label="Close"
        >
          <i class="fas fa-times"></i>
        </button>
      </header>

      <div class="body">
        <div class="card-grid">
          <button
            v-for="meta in cards"
            :key="meta.type"
            type="button"
            class="type-card"
            :class="{ disabled: !meta.available }"
            :disabled="!meta.available"
            @click="meta.available && pick(meta.type)"
          >
            <div class="type-card-head">
              <span class="type-icon"><i :class="meta.icon"></i></span>
              <span class="type-label">{{ meta.label }}</span>
              <span v-if="!meta.available" class="coming-soon">Coming soon</span>
            </div>
            <p class="type-summary">{{ meta.summary }}</p>
            <p class="type-description">{{ meta.description }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE_META } from '../../constants/retentionMessageTypes';

export default {
  name: 'RetentionMessageTypePicker',
  data() {
    return {
      cards: MESSAGE_TYPE_META
    };
  },
  methods: {
    pick(type) {
      this.$emit('pick', type);
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(8, 14, 22, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fade 0.15s ease;
}

@keyframes fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.modal-card {
  width: min(820px, calc(100vw - 2rem));
  max-height: calc(100vh - 4rem);
  background: #1a2332;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

header h3 {
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
  color: #fff;
  font-weight: 600;
}

.hint {
  margin: 0;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.82rem;
  line-height: 1.4;
}

.icon-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  font-size: 1rem;
  cursor: pointer;
  padding: 0.35rem 0.5rem;
  border-radius: 6px;
  margin-left: auto;
}

.icon-btn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.body {
  padding: 1.25rem;
  overflow-y: auto;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.85rem;
}

.type-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
  padding: 1rem 1.1rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.06s ease;
  font: inherit;
}

.type-card:hover:not(:disabled) {
  border-color: rgba(3, 179, 218, 0.6);
  background: rgba(3, 179, 218, 0.05);
}

.type-card:active:not(:disabled) {
  transform: translateY(1px);
}

.type-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.type-card-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(3, 179, 218, 0.18);
  color: #6dd0ea;
  font-size: 0.95rem;
}

.type-card.disabled .type-icon {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.45);
}

.type-label {
  font-size: 0.98rem;
  font-weight: 600;
  color: #fff;
}

.coming-soon {
  margin-left: auto;
  background: rgba(255, 192, 50, 0.18);
  color: #ffc832;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 2px 7px;
  border-radius: 999px;
}

.type-summary {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.4;
}

.type-description {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.45;
}

@media (max-width: 720px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
